import { render, staticRenderFns } from "./auth-body.vue?vue&type=template&id=0fbdc6cf&scoped=true&lang=pug&"
var script = {}
import style0 from "./auth-body.vue?vue&type=style&index=0&id=0fbdc6cf&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbdc6cf",
  null
  
)

export default component.exports